import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Document, Page } from "react-pdf";
import { setupPdfWorker } from "utils/setupPdfWorker";
import { buildPdfFileSource } from "../utils/pdfFileSource";

setupPdfWorker();

/** Inline PDF preview — avoids iframe (API sets X-Frame-Options: deny). */
const PreviewPdfViewer = ({ url }) => {
	const token = useSelector((state) => state.token);
	const [numPages, setNumPages] = useState(null);
	const [error, setError] = useState(null);

	const file = useMemo(() => buildPdfFileSource(url, token), [url, token]);

	if (!url) return null;

	return (
		<Box
			sx={{
				mt: 2,
				border: "1px solid",
				borderColor: "divider",
				borderRadius: 1,
				overflow: "auto",
				maxHeight: 520,
				bgcolor: "grey.100",
			}}
		>
			{error && (
				<Typography color="error" variant="body2" sx={{ p: 2 }}>
					{error}
				</Typography>
			)}
			<Document
				file={file}
				onLoadSuccess={({ numPages: n }) => {
					setNumPages(n);
					setError(null);
				}}
				onLoadError={(err) =>
					setError(err?.message || "Could not load preview PDF. Use Open in new tab.")
				}
				loading={
					<Box display="flex" justifyContent="center" p={4}>
						<CircularProgress size={28} />
					</Box>
				}
			>
				{Array.from({ length: numPages || 0 }, (_, i) => (
					<Page key={i + 1} pageNumber={i + 1} width={680} renderTextLayer={false} renderAnnotationLayer={false} />
				))}
			</Document>
		</Box>
	);
};

export default PreviewPdfViewer;
